import { axiosInstance } from "../axios";

/**
 * Influencer discovery paging (T212648 / T212649).
 *
 * The first page of each list is server-rendered into the mount point, so these are only
 * called for load-more and for the tab the page did not start on.
 */

export const fetchSuggestedInfluencers = async ({ skip = 0, take = 8 } = {}) => {
  const response = await axiosInstance.get("/umbraco/api/influencers/suggested", {
    params: { skip, take },
  });
  return response.data;
};

export const fetchFollowedInfluencers = async ({ skip = 0, take = 8 } = {}) => {
  const response = await axiosInstance.get("/umbraco/api/influencers/following", {
    params: { skip, take },
  });
  return response.data;
};
